import { render, staticRenderFns } from "./LocationMessage.vue?vue&type=template&id=388f7794&scoped=true&"
import script from "./LocationMessage.vue?vue&type=script&lang=js&"
export * from "./LocationMessage.vue?vue&type=script&lang=js&"
import style0 from "./LocationMessage.vue?vue&type=style&index=0&id=388f7794&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f7794",
  null
  
)

export default component.exports